import Home from '@/components/screens/home/Home';
import { NextPage, GetStaticProps } from 'next';
import { API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBookPage, IBooksPageData } from '@/interfaces/booksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { IAdvertisingBlock } from '@/interfaces/advertisingBlock.interface';
import { IPopularBooks } from '@/interfaces/popularBooks.interface';
import { ICollections } from '@/interfaces/collections.interface';

interface IHomePage extends IWidgetsSideBar {
  popularBooks: IPopularBooks;
  newBooks: IBookPage;
  oneNewBook: IBooksPageData;
  advertisingBlock: IAdvertisingBlock;
  freeBooks: IBookPage;
  collections: ICollections;
}

const HomePage: NextPage<IHomePage> = ({ popularBooks, newBooks, oneNewBook, todayWidget, popularBooksWidget, advertisingBlock, freeBooks, collections }) => {
  return <Home collections={collections} popularBooks={popularBooks} newBooks={newBooks} oneNewBook={oneNewBook} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} advertisingBlock={advertisingBlock} freeBooks={freeBooks} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const [popularRes, newRes, advertisingBlockRes, freeBooksRes, collectionsRes] = await Promise.all([
    fetch(`${API_URL}main-page/main-page-popular-books`),
    fetch(`${API_URL}satellite/books/news?page=1&page_size=13`),
    fetch(`${API_URL}advertising_block`),
    fetch(`${API_URL}satellite/books?free_book=true&page=1&page_size=20&sort_reversed=true`),
    fetch(`${API_URL}satellite/collections?page=1&page_size=6`),
  ]);
  const [popularBooks, newBooks, advertisingBlock, freeBooks, collections] = await Promise.all([popularRes.json(), newRes.json(), advertisingBlockRes.json(), freeBooksRes.json(), collectionsRes.json()]);

  const oneNewBook = newBooks.data.length > 0 ? newBooks.data.shift() : [];

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { popularBooks, newBooks, oneNewBook, todayWidget, popularBooksWidget, advertisingBlock, freeBooks, collections }, revalidate: REVALIDATE_TIME };
};

export default HomePage;
